module.exports = __webpack_public_path__ + "static/img/fluent-image-24-regular.dfe3337e.svg";